import { useState } from "react";
import { EPortInStep } from "@features/PortIn/components/ValidatePhoneNumber/enum/EPortInStep";
import { UseFormMethods, useWatch } from "react-hook-form";
import { ValidationCodeView } from "./ValidationCodeView";
import { IPortinForm } from "@features/PortIn/interface/IPortinForm";
import { useValidateCode } from "./hook/useValidateCode";

interface IParams {
    otpId: string;
    variantStyleButton: "outlined" | "contained";
    setIsFinished(newValue: boolean): void;
    updatePortInStep(nextStep: EPortInStep): void;
    setHasTooManyAttempt(hasTooManyAttempt: boolean): void;
    formMethods: UseFormMethods<IPortinForm>;
}

export const ValidationCode = (props: IParams) => {
    const { formMethods, otpId, setIsFinished, updatePortInStep, variantStyleButton, setHasTooManyAttempt } = props;

    const [userAttempt, setUserAttempt] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const { verifyCode } = useValidateCode(setErrorMessage);

    const incrementUserAttempt = () => {
        setUserAttempt(userAttempt + 1);
    };

    const resetUserAttempt = () => {
        setUserAttempt(0);
    };

    const retryCode = () => {
        updatePortInStep(EPortInStep.getCode);
    };

    const validationCodeValue = useWatch<string>({
        name: "validationCode",
        control: formMethods.control,
        defaultValue: "",
    });

    const validateCode = async () => {
        if (await formMethods.trigger("validationCode")) {
            setIsLoading(true);

            verifyCode(validationCodeValue, otpId).then((responseValidate) => {
                if (responseValidate?.valid) {
                    updatePortInStep(EPortInStep.successCode);
                    setIsFinished(true);
                } else {
                    if (userAttempt < 2) {
                        incrementUserAttempt();
                        setIsLoading(false);
                    } else {
                        resetUserAttempt();
                        setHasTooManyAttempt(true);
                        updatePortInStep(EPortInStep.getCode);
                    }
                }
            });
        }
    };

    return (
        <ValidationCodeView
            error={formMethods.errors.validationCode}
            errorMessage={errorMessage}
            isLoading={isLoading}
            register={formMethods.register}
            retryCode={retryCode}
            validateCode={validateCode}
            variantStyleButton={variantStyleButton}
        />
    );
};
